import { render, staticRenderFns } from "./DialogoBuscarFornecedor.vue?vue&type=template&id=7a99b9ac&scoped=true&"
import script from "./DialogoBuscarFornecedor.vue?vue&type=script&lang=js&"
export * from "./DialogoBuscarFornecedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a99b9ac",
  null
  
)

export default component.exports